$(document).ready(function () {

    // Function to show the popup
    function showPopup() {
        console.log("Showing popup.");
        const popupHTML = `
            <div id="cart-pop" class="cart-pop">
                <div class="cart-pop__content">
                <div class="closePopup" tabindex="0">X</div>
                    <h2>EXCLUSIVE FAIR UPDATES!</h2>
                    <iframe src="${FULLCLIENTTHEMEPATH}static/popup.html?sv=${SITEVERSION}" frameborder="0" id="popupIframe"></iframe>
                        <div class="cart-pop__buttons">
                </div>
            </div>
        </div>
    `;
        $('body').prepend(popupHTML);
    
        // Add click event listener to the button
        $('.closePopup').on('click', function() {
            console.log("Popup button clicked.");
            closePopup();
        });
        // Function to close the popup
        function closePopup() {
            console.log("Closing popup.");
            $('#cart-pop').remove();
        }
    }
    if (sessionStorage.getItem('popupSeen')) {
        return false;
      } else {
        sessionStorage.setItem('popupSeen', 'popupSeen');
        showPopup();
    }
});